import { memo } from 'react';
import styles from './styles.module.scss';
import { Image } from '@starsoft/common/components';
import { GameDetailsContentCardRowProps } from './props';

function GameDetailsContentCardRow({
  title,
  isLoading,
  value,
  coin,
  hideCoin,
  highlight,
}: GameDetailsContentCardRowProps) {
  if (isLoading) {
    return (
      <div className={styles.row}>
        <div className={styles.skeleton__value} />
        <div className={styles.skeleton__value} />
      </div>
    );
  }

  return (
    <div className={styles.row}>
      {title}
      <div
        className={`${styles.row__value} ${!highlight ? styles['row__value--empty'] : ''}`}
      >
        {!hideCoin && (
          <Image
            width={20}
            height={20}
            className={styles.card__reward__coin}
            alt={coin?.name}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${coin?.image}`}
          />
        )}
        {value ?? '--'}
      </div>
    </div>
  );
}

export default memo(GameDetailsContentCardRow);
